import type {ExternalServiceType} from 'nutshell-graphql-types';

import {analyticsClient} from '../../../analytics-client';

import type {ExternalServiceTypeFrontend} from './types';

export const trackMeetingLoggedAsNewActivity = (
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend
) => {
    switch (serviceType) {
        case 'ZOOM':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_ZOOM_LOGGED_AS_NEW_ACTIVITY);
            break;
        case 'GOOGLE_MEET':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_GOOGLE_MEET_LOGGED_AS_NEW_ACTIVITY);
            break;
        default:
            break;
    }
};

export const hasRecordingsColumnsVisible = (
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend
) => {
    if (serviceType === 'MICROSOFT_TEAMS') {
        return false;
    }

    return true;
};

export const stripCallPrefixIfNeeded = (name: string) => {
    if (name.startsWith('Call:')) {
        return name.substring(6);
    }

    return name;
};

export const trackLoggingFlowInitiated = (
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend,
    openedFrom: 'dashboard' | 'entity-page' | 'list'
) => {
    switch (serviceType) {
        case 'ZOOM':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_ZOOM_LOGGING_FLOW_INITIATED, {
                opened_from: openedFrom === 'list' ? `zoom-list` : openedFrom,
            });
            break;
        case 'GOOGLE_MEET':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_GOOGLE_MEET_LOGGING_FLOW_INITIATED, {
                opened_from: openedFrom === 'list' ? `google-meet-list` : openedFrom,
            });
            break;
        default:
            break;
    }
};

export const trackIntegrationEnabled = (serviceType: ExternalServiceType) => {
    switch (serviceType) {
        case 'GOOGLE_MEET':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_GOOGLE_MEET_INTEGRATION_ENABLED);
            break;
        case 'ZOOM':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_ZOOM_INTEGRATION_ENABLED);
            break;
        case 'MICROSOFT_TEAMS':
            analyticsClient.track(analyticsClient.EVENTS.TRACK_MICROSOFT_TEAMS_INTEGRATION_ENABLED);
            break;
        default:
            break;
    }
};

export const getIsNotetakerEnabledForServiceType = (
    serviceType: ExternalServiceType | ExternalServiceTypeFrontend,
    enabledMap: {
        isGMeetNotetakerEnabled: boolean;
        isZoomNotetakerEnabled: boolean;
        isMicrosoftTeamsNotetakerEnabled: boolean;
        isClickToCallNotetakerEnabled: boolean;
        isAircallNotetakerEnabled: boolean;
        isCallrailNotetakerEnabled: boolean;
        isDialpadNotetakerEnabled: boolean;
        isKixieNotetakerEnabled: boolean;
        isRingCentralNotetakerEnabled: boolean;
    }
): boolean => {
    switch (serviceType) {
        case 'GOOGLE_MEET':
            return enabledMap.isGMeetNotetakerEnabled;
        case 'ZOOM':
            return enabledMap.isZoomNotetakerEnabled;
        case 'MICROSOFT_TEAMS':
            return enabledMap.isMicrosoftTeamsNotetakerEnabled;
        case 'CLICKTOCALL':
            return enabledMap.isClickToCallNotetakerEnabled;
        case 'PHONES':
            return (
                enabledMap.isAircallNotetakerEnabled ||
                enabledMap.isCallrailNotetakerEnabled ||
                enabledMap.isDialpadNotetakerEnabled ||
                enabledMap.isKixieNotetakerEnabled ||
                enabledMap.isRingCentralNotetakerEnabled
            );
        default:
            return false;
    }
};
